export default {
      id: "play-active-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "icons-sprite.102705a.svg#play-active-usage",
      toString: function () {
        return this.url;
      }
    }